import { DeviceRegistrationLocationState } from "../deviceRegistrationLocationState";
import { DiscoveryResult, SiteDetailsValues } from "../NewUserFlow/newUserFlowState";

/**
 * Accumulated wizard state for the existing-user branch, threaded via
 * `history.push`/`goBack` exactly like `NewUserFlowState` — see
 * `deviceRegistrationLocationState.ts` for why. `customerName`, `siteId`/
 * `siteName`/`siteDetails` and `discoveryResult` deliberately match
 * `NewUserFlowState`'s fields of the same names — see `discoveryFlowState.ts`,
 * which both branches satisfy so `DeviceDiscoveryStep`/`CongratulationsStep`
 * can be shared. `siteDetails` is only present when the site was just created
 * via `NewSiteStep` (full address etc.) — an existing site picked off the
 * list only carries `siteId`/`siteName`.
 */
export interface ExistingUserFlowState extends DeviceRegistrationLocationState {
  userId?: string;
  hasProfessionalAccess?: boolean;
  customerId?: string;
  customerName?: string;
  siteId?: string;
  siteName?: string;
  siteDetails?: SiteDetailsValues;
  deviceId?: string;
  discoveryResult?: DiscoveryResult;
}

export const isLoggedIn = (
  state: ExistingUserFlowState | undefined
): state is ExistingUserFlowState & { userId: string } => !!state && !!state.userId;

export const hasCustomerSelected = (
  state: ExistingUserFlowState | undefined
): state is ExistingUserFlowState & { customerId: string; customerName: string } =>
  !!state && !!state.customerId && !!state.customerName;

export const hasSiteSelected = (
  state: ExistingUserFlowState | undefined
): state is ExistingUserFlowState & { siteId: string; siteName: string } =>
  !!state && !!state.siteId && !!state.siteName;
